<template>
  <div v-if="testimonials && isDynamic || !isDynamic" class="container-padding-x bg-white">
    <div class="max-w-7xl mx-auto py-16 md:py-48">
      <h3 class="mb-4 text-center font-semibold text-4xl md:text-5xl">{{ heading }}</h3>

      <h4 v-if="subHeading" class="text-center font-medium text-1xl">{{ subHeading }}</h4>

      <div v-if="isDynamic" class="flex flex-wrap mt-6">
        <div v-for="testimonial in testimonials" :key="testimonial.testimonialRef" class="flex w-full sm:w-1/2 px-0 pt-4 sm:px-4">
          <FontAwesomeIcon :icon="faQuoteLeft" class="text-xl sm:text-5xl text-brand mr-4 sm:mr-6" />
          <div>
            <p class="text-sm leading-relaxed mb-2">
              {{ testimonial.testimonial }}
            </p>

            <UtilTextLink
              :to="`/profile/${testimonial.user[0].firstName}-${testimonial.user[0].lastName}/${testimonial.user[0].userRef}`"
              class="no-underline font-semibold text-sm"
            >
              <span>{{ `${testimonial.user[0].firstName} ${testimonial.user[0].lastName.charAt(0)}. - ${testimonial.tagline}` }}</span>
            </UtilTextLink>
          </div>
        </div>
      </div>

      <div v-else class="flex flex-wrap mt-6">
        <div class="flex w-full sm:w-1/2 px-0 pt-4 sm:px-4">
          <FontAwesomeIcon :icon="faQuoteLeft" class="text-xl sm:text-5xl text-brand mr-4 sm:mr-6" />
          <div>
            <slot name="testimonialOne" />
          </div>
        </div>

        <div class="flex w-full sm:w-1/2 px-0 pt-4 sm:px-4">
          <FontAwesomeIcon :icon="faQuoteLeft" class="text-xl sm:text-5xl text-brand mr-4 sm:mr-6" />
          <div>
            <slot name="testimonialTwo" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LegacyApi from '@/lib/api/legacy'
  import {shuffle} from 'lodash'
  import {faQuoteLeft} from '@fortawesome/pro-solid-svg-icons'
  import UtilTextLink from '@/components/utils/UtilTextLink'

  export default {
  name: 'WidgetTestimonials',
  components: {
    UtilTextLink
  },
  created() {
    if (this.isDynamic) {
      this.getTestimonial()
    }
  },
  props: {
    isDynamic: {
      type: Boolean,
      default: true,
      required: false
    },
    heading: {
      type: String,
      required: true
    },
    subHeading: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      testimonialsApi: new LegacyApi(),
      testimonials: null,
      faQuoteLeft
    }
  },
  methods: {
    async getTestimonial() {
      await this.testimonialsApi.get('testimonials.get')

      this.testimonials = shuffle(this.testimonialsApi.data).slice(0, 2)
    },
  }
}
</script>

